module.exports = __webpack_public_path__ + "static/img/onozuka_04.7667763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/onozuka_04.jpg
// module id = 09Vu
// module chunks = 0